import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Slider,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./store";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ui from "./store/ui";
import advanced from "./store/advanced";

function Advanced({ readOnly }: { readOnly: boolean }) {
  const dispatch = useDispatch();
  const { fontSize, textOffsetFromIcon, iconSize, strokeWidth } = useSelector(
    (state: RootState) => state.document.advanced
  );
  const expanded = useSelector(
    (state: RootState) => state.uiState.advancedExpanded
  );

  return (
    <Accordion
      expanded={expanded}
      onChange={() => dispatch(ui.actions.advancedExpandedToggled())}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant={"subtitle1"}>
          Advanced {readOnly && "(read only)"}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container direction="column">
          <Grid item container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Typography gutterBottom>Font Size</Typography>
              <Slider
                valueLabelDisplay="on"
                value={fontSize}
                onChange={(_, value) =>
                  dispatch(
                    advanced.actions.updated({ fontSize: value as number })
                  )
                }
                step={0.1}
                marks
                min={1}
                max={5}
                disabled={readOnly}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography gutterBottom>Text Offset</Typography>
              <Slider
                valueLabelDisplay="on"
                value={textOffsetFromIcon}
                onChange={(_, value) =>
                  dispatch(
                    advanced.actions.updated({
                      textOffsetFromIcon: value as number,
                    })
                  )
                }
                step={0.1}
                marks
                min={5}
                max={8}
                disabled={readOnly}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Typography gutterBottom>Icon Size</Typography>
              <Slider
                valueLabelDisplay="on"
                value={iconSize}
                onChange={(_, value) =>
                  dispatch(
                    advanced.actions.updated({ iconSize: value as number })
                  )
                }
                step={0.1}
                marks
                min={1}
                max={7}
                disabled={readOnly}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography gutterBottom>Icon Stroke Width</Typography>
              <Slider
                valueLabelDisplay="on"
                value={strokeWidth}
                onChange={(_, value) =>
                  dispatch(
                    advanced.actions.updated({ strokeWidth: value as number })
                  )
                }
                step={0.05}
                marks
                min={0}
                max={1}
                disabled={readOnly}
              />
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

export default Advanced;
